import { createGlobalStyle } from "styled-components";

const globalStyles = createGlobalStyle`
    @import url('https://fonts.googleapis.com/css2?family=Gothic+A1:wght@200;400;700&display=swap');
    @font-face { font-family: 'Cafe24Ohsquare'; src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2001@1.1/Cafe24Ohsquare.woff') format('woff'); font-weight: normal; font-style: normal; }
    *{
        padding: 0;
        margin: 0;
        box-sizing: border-box;
        font-family: 'Gothic A1', sans-serif;
    }
    a{
        text-decoration: none;
        color: inherit;
    }

    ol,
    ul{
        list-style: none;
    }
    
    body{
        font-size: 14px;
        overflow-y: scroll;
    }
`;

export default globalStyles;
